import './secondary-custom-button.styles.scss';

const SecondaryCustomButton = ({ onClick, label, classes, id }) => {
  console.log('id', id);
  return (
    <button
      className={`reversed-button ${classes ? classes : ''}`}
      onClick={onClick}
      id={id}>
      <span id={id}>{label}</span>
      {/* <ArrowIcon className="arrow-icon" id={id} /> */}
      <svg
      className="arrow-icon" 
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        id={id}>
        <path
          id={id}
          d="M4.16669 10.0003H15.8334M15.8334 10.0003L10 4.16699M15.8334 10.0003L10 15.8337"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  );
};

export default SecondaryCustomButton;
